import GlobalNotice from '../ui/GlobalNotice';

const Body = ({ children }) => {
    return (
        <div className="voxycure-editor__body" >
            <GlobalNotice />
            {children}
        </div>
    );
};

export default Body;
